import {action, computed, observable} from 'mobx';
import {differenceInYears} from 'date-fns';

export default class {
  @observable isFormSubmitted = false;
  @observable isUserUnpledged = false;
  @observable birthdate = {
    birthMonth: '',
    birthDay: '',
    birthYear: '',
  };
  @observable shouldSaveBirthdate = true;

  @action updateBirthdate = (event) => {
    const {target} = event;
    if (target.value != undefined) {
      this.birthdate[target.name] = target.value;
    }
  }

  @action hasValidBirthdate = () => Object.values(this.birthdate).every(datePart => (datePart != '' && !isNaN(datePart)));

  @computed get fullBirthdate() {
    if(!this.hasValidBirthdate()) return null;
    return new Date(`${this.birthdate.birthMonth}-${this.birthdate.birthDay}-${this.birthdate.birthYear}`);
  }

  @computed get calculatedAge() {
    return differenceInYears(new Date(), this.fullBirthdate);
  }

  saveBirthday = () => {
    if(!this.hasValidBirthdate()) return;

    $.ajax({
      data: { user: { birthday: this.fullBirthdate } },
      dataType: 'json',
      method: 'PUT',
      timeout: '2000',
      url: '/api/v1/user',
    });
  };
}
